import { Box } from '@material-ui/core';
import React from 'react'
import { MIN_PERCENT_FROM_VIEW_PROGRESS, MIN_PERCENT_FROM_VIEW_VALUE_PROGRESS } from '../../utils/Constants/ProjectReportConstants';

interface ProgressBarSegmentedProps {
  data: Record<string, number>;
  options?: any;
  showPercent?: boolean;
}

const MultipleProgressBar: React.FC<ProgressBarSegmentedProps> = ({ data, options, showPercent = true }) => {
  const total = Object.values(data).reduce((acc: number, val: number) => acc + val, 0);

  return (
    <Box width="100%" borderRadius={options?.borderRadius || 4} overflow="hidden" display="flex" height={options?.height || 16} boxShadow={options?.boxShadow || 1}>
      {Object.entries(data).map(([key, value]) => {
        const percent = (value / total) * 100;
        return (
          <Box
            key={key}
            style={{
              width: `${percent}%`,
              backgroundColor: options?.backgroundColor[key] || '#ccc',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              color: options?.color[key] || '#fff',
              paddingLeft: showPercent && percent >= MIN_PERCENT_FROM_VIEW_PROGRESS ? '8px' : 0,
              fontSize: options?.fontSize || 12,
            }}
          >
            {(showPercent && percent >= MIN_PERCENT_FROM_VIEW_VALUE_PROGRESS) && (`${Math.round(percent)}%`)}
          </Box>
        );
      })}
    </Box>
  );
}

export default MultipleProgressBar;